import router, {setRouter} from '@/router'
import Cookie from '@/utils/cookie.js'
import { S_BtnPowerConsts, D_BtnPowerConsts } from '@/utils/powerConsts.js'
import { judgeRemovePureItemWhitelist } from '@/api/prod/center/index'
import { queryAmountDigit } from '@/api/base/index.js';
import { DEFAULT_AMOUNT_DIGIT } from '@/dictionary/index.js';

const user = {
  state: () => ({
    userInfo: {},
    erpUserInfo: {},
    menuConf: [],
    bindRelationUrl: '', // 需要绑定供分销关系的url 绑定完后记得清除
    removePureItem: false,  // 是否在移除纯商品白名单
    featureCodes:[], // 功能白名单
    amountDigit: DEFAULT_AMOUNT_DIGIT,// 金额保留小数位数
    brandConfigTableList: [], // pdd铺货模板副本
  }),
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setErpUserInfo (state, userInfo) {
      state.erpUserInfo = userInfo
    },
    setMenuConf (state, menuConf) {
      state.menuConf = menuConf
    },
    setBindRelationUrl (state, url) {
      state.bindRelationUrl = url
    },
    setRemovePureItem(state, val) {
      state.removePureItem = val;
    },
    setAmountDigit(state, val) {
      state.amountDigit = val;
    },
    setBrandConfig(state, brandConfig) {
      state.brandConfigTableList = brandConfig;
    },
  },
  actions: {
    LOGOUT({dispatch, state, commit}) {
      const {account, companyName} = state.userInfo
      window._last_r = router.currentRoute

      window._last_r.name !== 'l_index' && router.replace({name: 'l_index', params: {
        userName: account || '',
        companyName: companyName || ''
      }});
      dispatch("clearUserInfo")
      dispatch("resetNavTabs")
      dispatch('clearShops')
      dispatch("clearRePublishRowData")
      dispatch('clearDisplayRePublishRowData')
      dispatch('clearPlatformQuota')
      commit('setActiveName', 'onShelvesLog')
    },
    clearUserInfo({commit, dispatch}) {
      dispatch("setUserInfo", {})
      dispatch("setMenuConf", [])
      dispatch('clearPlatformQuota')
    },
    setMenuConf({commit}, menuConf) {
      console.log('%c [ menuConf ]-64', 'font-size:13px; background:pink; color:#bf2c9f;', menuConf)
      setRouter(menuConf, router)
      commit("setMenuConf", menuConf)
    },
    setUserInfo({commit, dispatch}, userInfo) {
      window.localStorage.setItem("userinfo", JSON.stringify(userInfo))
      let nowCenseid = `${Cookie.get('_censeid')}_${userInfo.id}`
      localStorage.setItem('_censeid', nowCenseid);
      commit("setUserInfo", userInfo)
      if (userInfo && userInfo.companyId) {
        dispatch('setAmountDigitAction');
        dispatch('fetchPlatformQuota', { force: true });
      }
    },
    setErpUserInfo({commit}, userInfo) {
      /**
       * 补充RC.user对象，防止kmui商品选择弹窗报错
       */
      if (window.RC) {
        window.RC.user = {
          _data: userInfo,
          get(key) {
            if (!key) {
              return userInfo;
            }
            return userInfo[key];
          }
        }
      }

      commit("setErpUserInfo", userInfo)
    },
    setBindRelationUrl({commit}, url) {
      commit("setBindRelationUrl", url)
    },
    clearBindRelationUrl({commit}) {
      commit("setBindRelationUrl", '')
    },
    // 判断是否在去除纯商品逻辑白名单
    judgeRemovePureItemWhitelist({commit}) {
      return judgeRemovePureItemWhitelist().then(res => {
        commit('setRemovePureItem', res.data);
      }).catch(() => {
        commit('setRemovePureItem', false);
      });
    },
    // 设置金额精度
    setAmountDigitAction({state, commit}) {
      console.log('获取金额精度===')
      if (state.userInfo.companyId) {
        queryAmountDigit({companyId: state.userInfo.companyId}).then(data => {
          commit('setAmountDigit', data);
        });
      }
    },
    setBrandConfig({commit}, brandConfig) {
      let configList = []
      if (brandConfig.length) {
        brandConfig.map(item => {
          if (item.shopIds.length) {
            configList.push(item)
          }
        })
      }
      commit("setBrandConfig", configList)
    },
  },
  getters: {
    userInfo(state) {
      return state.userInfo
    },
    erpUserInfo(state) {
      return state.erpUserInfo
    },
    erpUserWarehouseMap(state) {
      const warehouseExtras = state.erpUserInfo?.warehouseExtras || [];
      const warehouses = state.erpUserInfo?.warehouses || [];
      const wmap = warehouseExtras.concat(warehouses).reduce((map, warehouse) => {
        map[warehouse.id] = warehouse;
        return map;
      }, {});
      return wmap;
    },
    // 是否是供销商
    isSupplier(state) {
      return state.userInfo.loginIdentity == 1;
    },
    // 是否是分销商
    isDistributor(state) {
      return state.userInfo.loginIdentity == 2;
    },
    featureCodes(state) {
      return state.userInfo.featureCodes || [];
    },
    // 按钮权限常量
    userBtnPowerConsts(state) {
      if(state.userInfo.loginIdentity == 1) {
        return S_BtnPowerConsts;
      } else if(state.userInfo.loginIdentity == 2){
        return D_BtnPowerConsts;
      } else {
        return {};
      }
    },
    bindRelationUrl(state) {
      return state.bindRelationUrl
    },
    routerPrefix(state) {
      let prefix = ''
      if(state.userInfo.loginIdentity == 1) {
        prefix = 's_'
      } else if(state.userInfo.loginIdentity == 2){
        prefix = 'd_'
      } else {
        prefix = ''
      }
      return prefix;
    },
    removePureItem(state) {
      return state.removePureItem;
    },
    amountDigit(state) {
      return state.amountDigit;
    },
    brandConfigTableList(state) {
      return state.brandConfigTableList;
    },
    hasGoodsFissionRule(state){
      let prod = state.menuConf.find(item => ['/distributor/prod','/supplier/prod'].includes(item.path));
      let goodsFissionRule = prod.children.find(item => ['/distributor/prod/goods_fission_rule','/supplier/prod/goods_fission_rule'].includes(item.path))
      return !!goodsFissionRule;
    },
    hasMyShopPower(state){
      let commodity = state.menuConf.find(item => item.path === '/supplier/commodity');
      if (!commodity || !commodity.children) return false;
      return !!commodity.children.find(item => item.path === '/supplier/commodity/myShop');
    }
  }
}

export default user
